import React, { useRef} from 'react';
import "./contact.css"
import {MdOutlineMail} from 'react-icons/md'
import {BsInstagram, BsWhatsapp} from 'react-icons/bs'
import emailjs from 'emailjs-com'
import { useTranslation } from "react-i18next";


const Contact = () => {
  const { t } = useTranslation();
  const form = useRef()
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_regi9yk', 'template_zf3okhk', form.current, 'Y0QsGnvNKzvzclT_9')
    e.target.reset()
  };


  return (
    <section id='contact'>
        
      <h5 className='text-light'>{t("getintouch")}</h5>
      <h2>{t("contactme")}</h2>

      <div className="container contact__container">
        <div className="contact__options">
         <article className='contact__option'>
          <MdOutlineMail className='contact__option-icon'/>
          <h4>Email</h4>
          <h6>joaovictorlizsilveira@gmail.com</h6>
          <a href="mailto:joaovictorlizsilveira@gmail.com" target="_blank">{t("sendmessage")}</a>
         </article>
         <article className='contact__option'>
          <BsInstagram className='contact__option-icon'/>
          <h4>Instagram</h4>
          <h5>João Victor</h5>
          <a href="https://www.instagram.com/joaovc_liz/" target="_blank">{t("sendmessage")}</a>
         </article>
         <article className='contact__option'>
          <BsWhatsapp className='contact__option-icon'/>
          <h4>WhatsApp</h4>
          <h5>+353 087 189 0030</h5>
          <a href="https://api.whatsapp.com/send?phone=3530871890030" target="_blank">{t("sendmessage")}</a>
         </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
            <input type="text" name='name' placeholder={t("templateform.name")} required/>
            <input type="email" name="email" placeholder={t("templateform.email")} required />
            <textarea name="message" rows="7" placeholder={t("templateform.message")} required></textarea>
            <button type='submit' className='btn btn-primary'>{t("sendmessage")}</button>
        </form>
      </div>
   

    </section>
  )
}

export default Contact